import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Employeeinterface() {
  return (
    <section className="employee_interface p-100 text_una">
      <Container>
        <Row>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              <strong>UNA Employer Interface</strong>
              <br /> Giving Employers A Chance To Hire Top Students Without
              Looking For Them.
            </h2>
            <p>
              Tekrevol made sure to offer unique interfaces to employers and
              candidates tailored to what was needed. The employer interface was
              designed with ease in mind to ensure companies could register to
              the portal, create a company profile, and reach out to fresh
              graduates who could be potential employees. The job portal allowed
              them to connect with the candidate using the in-app messaging
              option or the other contact details on candidate profiles
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1 offset-md-1"
          >
            <div className="challenge_img text-center">
              <StaticImage
                src="../../../images/case-studies/una/employer_img.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={756}
                height={769}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Employeeinterface;
